import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import utils from '../../../util/Util';
import { Row, Col } from 'reactstrap';
import TableGrid from '../../../components/tableGrid/TableGrid'
import consts from '../../../util/Consts';
import { GetPurchaseOrderDetail, UpdatePurchaseOrderDetail, PrintPO } from '../../../redux/actions/HttpRequest';
import LoadingDialog from '../../../components/loadingDialog/LoadingDialog';
import './PoDetails.css';

class PurchaseDetails extends PureComponent {

    Columns = [
        { name: '', key: 'arrow' },
        { name: 'Part Name', key: 'partName' },
        { name: 'Quantity', key: 'quantity' },
        { name: 'Invoice#', key: 'invoiceNumber' },
        { name: 'Part Cost', key: 'partCost', type: 'currency' },
        { name: 'Extension', key: 'extension', type: 'currency' },
        { name: 'MFG', key: 'mfg' },
        { name: 'MODEL#', key: 'model' },
        { name: 'Serial#', key: 'serial' },
        { name: 'ACK#', key: 'ack' }
    ]

    CommentColumns = [
        { name: '', key: 'arrow', width: "45px" },
        { name: 'DATE', key: 'date', width: "145px" },
        { name: 'COMMENTS', key: 'comment', width: "500px" },
        { name: '', key: 'viewButton', type: 'viewButton', width: "65px" }
    ]

    constructor(props) {
        super(props);
        
        const isSessionEmpty = sessionStorage.length;
        if (isSessionEmpty === 0) {
            this.props.history.replace("/");
        }

        this.state = {
            showModal: true,
            Data: { parts: [], comments: [] },
            isFetching: true,
            userData: JSON.parse(sessionStorage.getItem(consts.sessionVariables.UserData)),
        }

        this.PurchaseOrderNumber = sessionStorage.getItem(consts.sessionVariables.PurchaseOrderNumber);
        this.CertNumber = sessionStorage.getItem(consts.sessionVariables.CertNumber);
        this.getPODetails();

        this.printReceipt = this.printReceipt.bind(this);
    }

    componentWillReceiveProps(nextProps) {
        let me = this;
        if (nextProps.GetPurchaseOrderDetail && nextProps.GetPurchaseOrderDetail.data && nextProps.GetPurchaseOrderDetail.data !== this.props.GetPurchaseOrderDetail.data) {
            const { data } = nextProps.GetPurchaseOrderDetail.data;

            this.setState({ Data: data, isFetching: false }, () => {
                if (this.state.POupdate) me.setState({ updateAlert: true, POupdate: false });
                setTimeout(() => { me.setState({ updateAlert: false }) }, 5000);
            });
        }

        if (nextProps.UpdatePurchaseOrderDetail && nextProps.UpdatePurchaseOrderDetail.data && nextProps.UpdatePurchaseOrderDetail.data !== this.props.UpdatePurchaseOrderDetail.data) {
            const { success } = nextProps.UpdatePurchaseOrderDetail.data;

            if (success) {
                this.setState({ POupdate: true }, () => {
                    this.getPODetails();
                });
            }
        }

        if (nextProps.PrintPO && nextProps.PrintPO.data && nextProps.PrintPO.data !== this.props.PrintPO.data) {
            const { data } = nextProps.PrintPO.data;
            if (window.navigator && window.navigator.msSaveOrOpenBlob) { // for IE
                utils.downloadFile(data, 'pdf', 'POList_');
            } else this.printPreview(data);
        }
    }

    getPODetails = () => {
        this.props.dispatch(GetPurchaseOrderDetail.request({}, 'PurchaseOrderNumber=' + this.PurchaseOrderNumber, "GET"));
    }

    navigate = route => {
        this.props.history.push(route);
    }

    routeToClaim = claimNumber => {
        sessionStorage.setItem(consts.sessionVariables.ClaimNumber, claimNumber);
        sessionStorage.setItem(consts.sessionVariables.ClaimRedirectFrom, '/PurchaseOrderDetails');
        this.props.history.push("/ClaimDetails");
    }

    printPreview = (data, type = 'application/pdf') => {
        let blob = null;
        blob = this.b64toBlob(data, type);
        const blobURL = URL.createObjectURL(blob);
        const theWindow = window.open(blobURL);
        if (theWindow) {
            const theDoc = theWindow.document;
            const theScript = document.createElement('script');
            function injectThis() {
                window.print();
            }
            theScript.innerHTML = `window.onload = ${injectThis.toString()};`;
            theDoc.body.appendChild(theScript);
        }
    };

    b64toBlob = (content, contentType) => {
        contentType = contentType || '';
        const sliceSize = 512;
        // method which converts base64 to binary
        const byteCharacters = window.atob(content);

        const byteArrays = [];
        for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
            const slice = byteCharacters.slice(offset, offset + sliceSize);
            const byteNumbers = new Array(slice.length);
            for (let i = 0; i < slice.length; i++) {
                byteNumbers[i] = slice.charCodeAt(i);
            }
            const byteArray = new Uint8Array(byteNumbers);
            byteArrays.push(byteArray);
        }
        const blob = new Blob(byteArrays, {
            type: contentType
        }); // statement which creates the blob
        return blob;
    };

    handleModal = CommentDetails => {
        this.setState({ showModal: !this.state.showModal, CommentDetails: CommentDetails });
    }
    
    handleChange = (e) => {
        this.setState({ isFetching: true });
        let Data = this.state.Data;
        Data.status = e.target.value;
        this.setState({ Data: Data, isFetching: false });
        this.UpdatePODetail('Status', Data.status);
    }

    printReceipt() {
        this.props.dispatch(PrintPO.request({}, 'PurchaseOrderNumber=' + this.PurchaseOrderNumber, "GET"));
    }

    onRowClick = () => {
        console.log("onRowClick PO details");
    }

    UpdatePODetail = (item, values) => {
        const { Data, userData } = this.state;

        let req = {
            user: userData.userName,
            poNumber: Data.poNumber.toString(),
            claimNumber: Data.claimNumber.toString(),
            updateString: item
        }

        let updateMessage;
        if (item === "Status") {
            req.status = values;

            updateMessage = "Status successfully updated";
        } else if (item === "Parts") {
            req.parts = {
                partId: values.partId,
                partCost: values.partCost.toString()
            }

            updateMessage = "Part Cost successfully updated";
        } else if (item === "Comments") {
            req.certificate = this.CertNumber;
            req.comments = {
                comment: values
            }

            updateMessage = "Comment successfully added";
        }

        this.setState({ isFetching: true, updateMessage: updateMessage }, () => this.props.dispatch(UpdatePurchaseOrderDetail.request(req)));
    }

    render() {
        const { Data, isFetching, updateAlert, updateMessage } = this.state;

        return (
            <Row className="justify-content-center  inner-container pt-3">
                <LoadingDialog isOpen={isFetching}></LoadingDialog>
                <section id="claims-section" className="claims-section">
                    <div className="container-fluid" >
                        <div className="row">
                            <div className="col-12">
                                <div className="heading-flex">
                                    <h1 className="section-title darkcolor font-main mb-3">Purchase Order Details</h1>
                                    <div className="button-wrapp mb-3 pointer">
                                        <a onClick={this.printReceipt} className="hide-on-print btn-web btn-export mb-2 ms-4">
                                            <img alt="export" src={require('.././../../assets/images/print.png').default} /> PRINT PO
                                        </a>
                                    </div>
                                </div>
                            </div>
                            <div className="col-12">
                                <div className="row detail-list mb-3">
                                    <div className="col-lg-4 col-md-4 detail-column">
                                        <div className="detail-name">
                                            <p className="font-main person-name color-default mb-3">{Data?.name}</p>
                                            <p className="person-address font-main mb-0">{Data?.address}</p>
                                            <p className="person-address font-main mb-0 mt-1 mb-3">{Data?.city} {Data?.city ? ', ' : ''} {Data?.state} {Data?.zip}</p>
                                            <p className="person-recept font-main mb-0 mt-1">Sales Rcpt#: {Data?.saleRecpt}</p>
                                            <p className="person-date font-main mb-0 mb-3 mt-1">Date: {Data?.purchaseDate}</p>
                                            <p className="person-phone font-main mt-1 mb-0 ">Phone: {Data?.phone}</p>
                                        </div>
                                    </div>
                                    <div className="col-lg-4 col-md-4 detail-column">
                                        <div className="detail-name">
                                            <Row className="claim-number">
                                                <Col md={7} className="font-main mb-0">Purchase Order</Col>
                                                <Col md={5} className="font-main mb-0"><span className="floatLeft" >{Data?.poNumber}</span></Col>
                                            </Row>
                                            <Row className="claim-number mt-10">
                                                <Col md={7} className="font-main mb-0">PO Date</Col>
                                                <Col md={5} className="font-main mb-0"><span className="floatLeft" >{Data?.date} </span></Col>
                                            </Row>
                                            <Row className="claim-number mt-10">
                                                <Col md={7} className="font-main mb-0">Claim#</Col>
                                                <Col md={5} className="font-main mb-0"><span onClick={() => this.routeToClaim(Data.claimNumber)} className="link floatLeft" >{Data?.claimNumber}</span></Col>
                                            </Row>
                                            <Row className="claim-number mt-10">
                                                <Col md={7} className="font-main mb-0">Dealer Store</Col>
                                                <Col md={5} className="font-main mb-0"><span className="floatLeft" >{Data?.dealerStore}</span></Col>
                                            </Row>
                                            <Row className="claim-number mt-10">
                                                <Col md={7} className="font-main mb-0">Type</Col>
                                                <Col md={5} className="font-main mb-0"><span className="floatLeft" >{Data?.type}</span></Col>
                                            </Row> 
                                            <Row className="claim-number mt-10">
                                                <Col md={7} className="font-main mb-0">Service Type</Col>
                                                <Col md={5} className="font-main mb-0"><span className="floatLeft" >{Data?.serviceType}</span></Col>
                                            </Row> 
                                            <Row className="claim-number mt-10">
                                                <Col md={7} className="font-main   mb-0">Status</Col>
                                                <Col md={5} className="font-main mb-0">
                                                    <div className="form-icon floatLeft">
                                                        <select
                                                            value={Data?.status}
                                                            onChange={this.handleChange}
                                                            name="status"
                                                            id="Pstatus"
                                                            className="form-control pointer"
                                                        >
                                                            {consts.PoStatusOptions && consts.PoStatusOptions.map(status => <option value={status.value}>{status.name}</option>)}
                                                        </select>
                                                        <span style={{ pointerEvents: "none" }}><img alt="" src={require('../../../assets/images/angle.png').default} /></span>
                                                    </div>
                                                </Col>
                                            </Row>
                                        </div>
                                    </div>
                                    <div className="col-lg-4 col-md-4 detail-column">
                                        <div className="detail-name">
                                            <p className="font-main color-default mb-0">{Data?.dName}</p>
                                            <p className="font-main mt-10 mb-0 mt-1">{Data?.dAddress}</p>
                                            <p className="font-main mb-0 mt-1">{Data?.dCity} {Data?.dCity ? ', ' : ''} {Data?.dState} {Data?.dZip}</p>
                                            <p className="font-main mt-10 mb-0 mt-1">{Data?.dPhone}</p>
                                        </div>
                                        <div className="divider"></div>
                                        <div className="detail-name">
                                            <p className="font-main mb-0">{Data?.wName}</p>
                                            <p className="font-main mt-10 mb-0 mt-1">{Data?.wAddress} </p>
                                            <p className="font-main mb-0">{Data?.wCity} {Data?.wCity ? ', ' : ''} {Data?.wState} {Data?.wZip}</p>
                                            <p className="font-main mt-10 mb-0 mt-1">{Data?.wPhone}</p>
                                        </div>
                                    </div>
                                </div>

                                <div className="mb-3">
                                    <TableGrid
                                        screenName={false}
                                        Data={Data?.parts}
                                        Columns={this.Columns}
                                        tableName="Parts"
                                        onRowClick={this.onRowClick}
                                        tableClassName="table-web"
                                        savePartCost={(val) => this.savePartCost(val)}
                                        UpdatePODetail={(item, values) => this.UpdatePODetail(item, values)}
                                    ></TableGrid>
                                </div>

                                <div className="mb-3">
                                    <TableGrid
                                        screenName={false}
                                        Data={Data?.comments}
                                        tableName="Comments"
                                        Columns={this.CommentColumns}
                                        AddCommentBtn={true}
                                        onRowClick={this.onRowClick}
                                        handleModal={(e) => this.handleModal(e)}
                                        UpdatePODetail={(item, values) => this.UpdatePODetail(item, values)}
                                        tableClassName="table-detail detail-summery"
                                        overflowVis={true}

                                    ></TableGrid>
                                </div>

                                <div className="heading-flex">
                                    <a onClick={() => this.navigate('/PurchaseOrders')} className="btn-darker btn-export mb-2 ms-1 pointer hide-on-print">
                                        <img alt="export" src={require('.././../../assets/images/back.png').default} /> BACK
                                    </a>
                                </div>
                            </div>

                            {updateAlert ? <div class="alert alert-primary successAlert font-main" role="alert"> {updateMessage} </div> : <></>}
                        </div>
                    </div>
                </section>
            </Row>
        );
    }
}

function mapStateToProps(state) {
    return {
        GetPurchaseOrderDetail: state.GetPurchaseOrderDetail,
        UpdatePurchaseOrderDetail: state.UpdatePurchaseOrderDetail,
        PrintPO: state.PrintPO
    };
}

var PurchaseDetailsModule = connect(mapStateToProps)(PurchaseDetails);

export default PurchaseDetailsModule;